var $820860ff69b4d53e$exports = {};
$820860ff69b4d53e$exports = {
    "removeButtonLabel": `Quitar`,
    "removeDescription": `Pulse Eliminar para quitar la etiqueta.`
};


export {$820860ff69b4d53e$exports as default};
//# sourceMappingURL=es-ES.mjs.map
